import { ScheduleTime } from 'models/broadcast.model';
import dayjs from 'dayjs';
import {
  ABBREVIATED_DATE_FORMAT,
  ABBREVIATED_TIME_FORMAT,
  DATE_FORMAT,
} from '../../common';

export const getTime = (date: Date, scheduleTime?: ScheduleTime) => {
  if (date) {
    return {
      hours: date.getHours(),
      minutes: date.getMinutes(),
    };
  }

  return {
    hours: scheduleTime?.hours ?? 0,
    minutes: scheduleTime?.minutes ?? 0,
  };
};

export const getValidTime = (time: number) => {
  if (time) {
    return String(time).length !== 2 ? `0${time}` : String(time);
  }

  return '00';
};

export const dateWithTimeToString = (date: Date | string = new Date()) => {
  try {
    return dayjs(date).format(DATE_FORMAT);
  } catch {
    return '';
  }
};

export const dateToString = (date: Date | string) => {
  try {
    return dayjs(date).format(ABBREVIATED_DATE_FORMAT);
  } catch {
    return '';
  }
};

export const timeToString = (date: Date | string) => {
  try {
    return dayjs(date).format(ABBREVIATED_TIME_FORMAT);
  } catch {
    return '';
  }
};
